var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Cuckoo extends Component {
    constructor() {
        super('Cuckoo', false);
        this.audioPlayers = [];
        this.isChirping = false;
        const assetPath = '/wp-content/themes/hanako-wp/dist/assets/sounds';
        this.audioPlayers[0] = new Audio();
        this.audioPlayers[0].src = assetPath + '/cuckoo-0.wav';
        this.audioPlayers[1] = new Audio();
        this.audioPlayers[1].src = assetPath + '/cuckoo-1.wav';
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.cuckooElement = $('#cuckoo');
            this.cuckooElement.on('click', (event) => {
                this.animate(this.getCurrentTimeIterationsCount());
            });
            setInterval(() => {
                this.checkTime();
            }, 1000);
            this.success();
        });
    }
    getCurrentTimeIterationsCount() {
        const hour = (new Date()).getHours() % 12;
        return (hour == 0) ? 12 : hour;
    }
    animate(iterations) {
        if (this.isChirping)
            return;
        this.isChirping = true;
        this.cuckooElement.css('--iterations', iterations).addClass('animated');
        this.chirp(iterations);
        setTimeout(() => {
            this.cuckooElement.removeClass('animated');
            this.isChirping = false;
        }, iterations * 1100);
    }
    chirp(iterations) {
        this.playSound();
        if (iterations == 1)
            return;
        let audioPlayLoop = 1;
        const audioPlayInterval = setInterval(() => {
            this.playSound();
            audioPlayLoop++;
            if (audioPlayLoop == iterations)
                clearInterval(audioPlayInterval);
        }, 1000);
    }
    playSound() {
        this.audioPlayers[0].play();
        setTimeout(() => {
            this.audioPlayers[1].play();
        }, 100);
    }
    checkTime() {
        let iterations = 0;
        const date = new Date();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        if (seconds == 0 && minutes % 30 == 0) {
            iterations = (minutes == 0) ? (hours == 0) ? 12 : hours % 12 : 1;
        }
        if (iterations > 0)
            this.animate(iterations);
    }
}
